<template>
  <div class="pv">
    <svg width="100%" viewBox="0 0 240 80" style="margin-bottom: 6px; overflow: visible">
      <defs>
        <linearGradient id="gx-prev-aGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#D4A946" stop-opacity=".3" />
          <stop offset="100%" stop-color="#D4A946" stop-opacity="0" />
        </linearGradient>
      </defs>
      <line v-for="v in [100, 200]" :key="v" x1="28" :y1="H - 20 - (v / 220) * cH" x2="232" :y2="H - 20 - (v / 220) * cH" stroke="rgba(255,255,255,.06)" stroke-width="1" />
      <text v-for="(l, j) in xLabels" :key="l" :x="28 + (j * 3 / 11) * cW" y="76" fill="rgba(200,192,224,.35)" font-size="7" text-anchor="middle">{{ l }}</text>
      <path :d="areaD" fill="url(#gx-prev-aGrad)" :style="{ strokeDasharray: 1400, strokeDashoffset: run ? 0 : 1400, transition: 'stroke-dashoffset 2.5s ease-out' }" />
      <path :d="lineD" fill="none" stroke="#D4A946" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :style="{ strokeDasharray: 1400, strokeDashoffset: run ? 0 : 1400, transition: 'stroke-dashoffset 2.5s ease-out' }" />
    </svg>
    <div class="pv__kpis">
      <div v-for="(k, i) in kpiDefs" :key="i" class="pv__kpi">
        <div class="pv__kpi-v" :style="{ color: k.c }">{{ k.v }}</div>
        <div class="pv__kpi-l">{{ k.l }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrevAnalytics',
  props: { run: { type: Boolean, default: false } },
  data() {
    return {
      data: [3, 5, 8, 13, 21, 34, 55, 89, 110, 145, 180, 220],
      labels: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      maxV: 220, W: 240, H: 80, pL: 28, pR: 8, pT: 8, pB: 20,
      kpis: [0, 0, 0],
      timer: null
    }
  },
  computed: {
    cW() { return this.W - this.pL - this.pR },
    cH() { return this.H - this.pT - this.pB },
    pts() {
      return this.data.map((d, i) => ({
        x: this.pL + (i / (this.data.length - 1)) * this.cW,
        y: this.H - this.pB - (d / this.maxV) * this.cH
      }))
    },
    lineD() {
      return this.pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ')
    },
    areaD() {
      const last = this.pts[this.pts.length - 1]
      return `${this.lineD} L${last.x},${this.H - this.pB} L${this.pL},${this.H - this.pB} Z`
    },
    xLabels() {
      return this.labels.filter((_, i) => i % 3 === 0)
    },
    kpiDefs() {
      return [
        { l: 'GMV增长', v: `+${this.kpis[0]}%`, c: '#4CAF7A' },
        { l: '转化率', v: `+${this.kpis[1]}%`, c: '#00C8F5' },
        { l: '复购率', v: `+${this.kpis[2]}%`, c: '#D4A946' }
      ]
    }
  },
  watch: {
    run(v) {
      if (this.timer) clearInterval(this.timer)
      if (!v) { this.kpis = [0, 0, 0]; return }
      this.timer = setInterval(() => {
        this.kpis = [
          Math.min(this.kpis[0] + 3, 156),
          Math.min(this.kpis[1] + 2, 68),
          Math.min(this.kpis[2] + 1, 42)
        ]
      }, 40)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.pv { width: 100%; }
.pv__kpis { display: flex; gap: 6px; }
.pv__kpi {
  flex: 1;
  padding: 5px 6px;
  border-radius: 7px;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(255, 255, 255, .1);
  text-align: center;
}
.pv__kpi-v { font-family: Inter; font-size: 13px; font-weight: 700; }
.pv__kpi-l { font-size: 9px; color: #8A95B0; }
</style>
